export { Icon, IconSizeName } from '$views/components/Icon/Icon'



// WEBPACK FOOTER //
// ./src/views/components/Icon/index.tsx